import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { active: Boolean }

  toggleNoise() {
    this.activeValue = !this.activeValue

    const feed = document.querySelector(".activity-list")
    if (feed) feed.classList.toggle("show-noise", this.activeValue)

    const status = this.element.querySelector(".feed-toggle-status")
    if (status) status.textContent = this.activeValue ? "zichtbaar" : "verborgen"
  }
}
